<template>
  <earning-statements></earning-statements>
</template>

<script>
import '@pagarme/earning-statements/web-comp'

export default {
  name: 'EarningStatementsPage'
}
</script>
